/**
 * PURPOSE: represents the different Marketplace types as an enum
 */
export enum ApiTypeEnum {
  BASIC = "BASIC",
  X_API_KEY = "X_API_KEY"
}
